document.addEventListener("DOMContentLoaded", () => {
    const playTriggers = document.querySelectorAll(".custom-video-play");

    if (!playTriggers) return;

    playTriggers.forEach((trigger) => {
        trigger.addEventListener("click", () => {
            const videoUrl = trigger.dataset.videourl;
            const videoContent = trigger.getAttribute("data-video-play");
            const iframeWrapItem = document.querySelector(
                '.pswp--custom-loader[data-index="0"] .pswp__container .pswp__item--second'
            );

            if (!iframeWrapItem) return;

            let zoomWrap = iframeWrapItem.querySelector(".pswp__zoom-wrap");
            if (!zoomWrap) {
                zoomWrap = document.createElement("div");
                zoomWrap.classList.add("pswp__zoom-wrap");
                zoomWrap.style.transform = "translate3d(0px, 0px, 0px) scale(1)";
                iframeWrapItem.append(zoomWrap);
            }

            const iframeVideoWrap = document.querySelector(".pswp--custom-loader[data-index='0']");
            const iframeVideoBg = document.querySelector(".pswp--custom-loader[data-index='0'] .pswp__bg");

            if (!iframeVideoWrap || !iframeVideoBg) return;

            applyStylesForVideo(iframeVideoWrap, iframeVideoBg, zoomWrap, videoContent);

            const closeButton = document.querySelector(
                ".pswp--custom-loader[data-index='0'] .pswp__button--close"
            );
            if (closeButton) {
                closeButton.addEventListener("click", () =>
                    resetVideo(iframeVideoWrap, iframeVideoBg, zoomWrap)
                );
            }

            window.addEventListener("scroll", () => resetVideo(iframeVideoWrap, iframeVideoBg, zoomWrap));
        });
    });

    function applyStylesForVideo(wrapper, bg, zoomWrap, content) {
        bg.style.opacity = "1";
        wrapper.style.position = "fixed";
        wrapper.style.opacity = "1";
        wrapper.className +=
            " pswp--custom-loader-upd pswp--supports-fs pswp--open pswp--video pswp--notouch pswp--css_animation pswp--svg pswp--visible pswp--animated-in pswp--has_mouse";
        wrapper.setAttribute("aria-hidden", "false");

        zoomWrap.innerHTML = content;

        lockScrolling();
        shiftGalleryItems("-200%", "200%");
    }

    function resetVideo(wrapper, bg, zoomWrap) {
        bg.style.opacity = "";
        wrapper.style.opacity = "";
        wrapper.className = "pswp pswp--custom-loader";
        wrapper.setAttribute("aria-hidden", "true");
        zoomWrap.innerHTML = "";

        unlockScrolling();
        shiftGalleryItems("", "");
    }

    function lockScrolling() {
        document.documentElement.setAttribute("data-scroll-locked", "");
        const body = document.body;
        body.dataset.scrollLockSavedOverflowYProperty = "visible";
        body.dataset.scrollLockSavedInlineOverflowProperty = "";
        body.dataset.scrollLockSavedInlineOverflowYProperty = "";
        body.dataset.scrollLockLocked = "true";
        body.dataset.scrollLockFilledGap = "true";
        body.dataset.scrollLockCurrentFillGapMethod = "padding";
    }

    function unlockScrolling() {
        document.documentElement.removeAttribute("data-scroll-locked");
        const body = document.body;
        delete body.dataset.scrollLockSavedOverflowYProperty;
        delete body.dataset.scrollLockSavedInlineOverflowProperty;
        delete body.dataset.scrollLockSavedInlineOverflowYProperty;
        delete body.dataset.scrollLockLocked;
        delete body.dataset.scrollLockFilledGap;
        delete body.dataset.scrollLockCurrentFillGapMethod;
    }

    function shiftGalleryItems(firstTransform, thirdTransform) {
        const firstItem = document.querySelector(".pswp--custom-loader[data-index='0'] .pswp__item--first");
        const thirdItem = document.querySelector(".pswp--custom-loader[data-index='0'] .pswp__item--third");

        if (firstItem) firstItem.style.transform = `translateX(${firstTransform})`;
        if (thirdItem) thirdItem.style.transform = `translateX(${thirdTransform})`;
    }
});